import React, { Component } from "react";
import { css } from "aphrodite/no-important";
import { styles } from "../pages/AccountStyles";

export default class AccountBackButton extends Component {
  render() {
    return (
      <div className={css(styles.backWrapper)}>
        {localStorage.getItem("house_id") !== 'undefined' && (
          <a href="/my-home" className={css(styles.backTitle)}>
            <strong className={css(styles.link)}>HomeView</strong>
          </a>
        )}
        <a href="/parents-home" className={css(styles.backTitle)}>
          <strong className={css(styles.link)}>InfoCare</strong>
        </a>
      </div>
    );
  }
}
